import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { EditPropertyData } from '@/schema/properties';

interface PropertyStatusProps {
  form: UseFormReturn<EditPropertyData>;
}

export function PropertyStatus({ form }: PropertyStatusProps) {
  const { control } = form;
  const { t, i18n } = useTranslation();
  const isRTL = useMemo(() => i18n.language === 'ar', [i18n.language]);

  return (
    <div
      className={cn(
        'flex items-center',
        isRTL ? 'flex-row-reverse gap-3' : 'flex-row gap-2'
      )}
      dir={'ltr'}
    >
      <Controller
        name="is_active"
        control={control}
        render={({ field }) => (
          <Switch
            id="is_active"
            checked={field.value}
            onCheckedChange={field.onChange}
          />
        )}
      />
      <Label
        htmlFor="is_active"
        className={cn(
          'cursor-pointer select-none',
          isRTL ? 'text-right' : 'text-left'
        )}
      >
        {t('properties.edit.status.propertyIsActive')}
      </Label>
    </div>
  );
}
